"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSearchResultFilters = void 0;
const index_1 = require("../index");
const useSearchResultFilters = (selectedTab, dictionary) => {
    const filters = (0, index_1.useFilters)(selectedTab, dictionary);
    const hierarchyFilters = (0, index_1.useHierarchyFilters)(selectedTab, dictionary);
    const clearAllRefinements = (0, index_1.useClearFilters)(filters, hierarchyFilters);
    const selectedFilterOptionsCount = (0, index_1.useSelectedFilterOptionsCount)();
    return {
        filters,
        hierarchyFilters,
        clearAllRefinements,
        selectedFilterOptionsCount,
    };
};
exports.useSearchResultFilters = useSearchResultFilters;
